import React, { FunctionComponent } from "react"
import { Grid, Typography, Button, TextField } from "@material-ui/core"
import { advanceStepper, reverseStepper } from "./reducer"
import { AudioPlayer } from "../../components/AudioPlayer"
import { useManualPageContext } from "./useManualPageContext"
import manualPageStyles from "./ManualPage.module.scss"
import promptStyles from "./PromptText.module.scss"

export const ApproveAudio: FunctionComponent = () => {
    const { sourceAudio, targetAudio, state, dispatch } = useManualPageContext()
    const { allLanguages, sourceLanguage, targetLanguage } = state
    const { originalText, translatedText } = state.fields

    return (
        <Grid container alignItems="stretch" spacing={3}>
            <Grid item className={manualPageStyles.Step__description}>
                <Typography variant="caption">
                    Preview your audio for accuracy and assess the impact of any selected affect
                    options. Click BACK if you'd like to make changes to any of the options.
                </Typography>
            </Grid>
            <Grid item className={manualPageStyles.Step__content}>
                <Grid
                    container
                    spacing={1}
                    direction="column"
                    justify="flex-start"
                    alignItems="flex-start"
                >
                    <Grid item>
                        <Typography variant="h6" gutterBottom>
                            Review Audio
                        </Typography>
                    </Grid>
                    <Grid item>
                        {sourceAudio?.data?.createAudio && (
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                data-testid="sourceLanguageTitle"
                            >{`${allLanguages?.[sourceLanguage].name ?? "loading..."}`}</Typography>
                        )}
                    </Grid>
                    <Grid item>
                        <AudioPlayer
                            playerId={"source-audio-player"}
                            audioFile={sourceAudio?.data?.createAudio}
                            loading={sourceAudio?.loading ?? false}
                            error={sourceAudio?.error}
                        />
                    </Grid>
                    <Grid item className={promptStyles.PromptText__griditem}>
                        {sourceAudio?.data?.createAudio && (
                            <TextField
                                label="Source Text"
                                value={originalText.value}
                                variant="outlined"
                                disabled
                                multiline
                                fullWidth
                                inputProps={{ "data-testid": "givenSourceText" }}
                            />
                        )}
                    </Grid>

                    <Grid item>
                        {targetAudio?.data?.createAudio && (
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                data-testid="targetLanguageTitle"
                            >{`${allLanguages?.[targetLanguage].name ?? "loading..."}`}</Typography>
                        )}
                    </Grid>
                    <Grid item>
                        <AudioPlayer
                            playerId={"target-audio-player"}
                            audioFile={targetAudio?.data?.createAudio}
                            loading={targetAudio?.loading ?? false}
                            error={targetAudio?.error}
                        />
                    </Grid>
                    <Grid item className={promptStyles.PromptText__griditem}>
                        {targetAudio?.data?.createAudio && (
                            <TextField
                                label="Translated Text"
                                value={translatedText.value}
                                variant="outlined"
                                disabled
                                multiline
                                fullWidth
                                inputProps={{ "data-testid": "givenTargetText" }}
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={manualPageStyles.Step__content}>
                <Button
                    data-testid="approveAudioBack"
                    id="approveAudioBack"
                    onClick={() => {
                        dispatch(reverseStepper())
                    }}
                >
                    Back
                </Button>
                <Button
                    data-testid="approveAudioNext"
                    id="approveAudioNext"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        dispatch(advanceStepper())
                    }}
                >
                    Next
                </Button>
            </Grid>
        </Grid>
    )
}
